export default __webpack_public_path__ + "static/media/eye.b85be1e0.svg";